var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 19.6,
    height: 19.6,
    rx: 2.8,
    fill: "#222222"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 19.6,
    height: 19.6,
    rx: 2.8,
    stroke: "white",
    strokeWidth: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10755_8718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.838 4.19434C11.0945 4.19434 9.67603 5.61277 9.67603 7.3563V8.73044H4.69004C4.30897 8.73044 4 9.03936 4 9.42048V15.1156C4 15.4967 4.30897 15.8056 4.69004 15.8056H11.7617C12.1428 15.8056 12.4517 15.4967 12.4517 15.1156V9.42048C12.4517 9.03936 12.1428 8.73044 11.7617 8.73044H11.3878V7.3563C11.3878 6.55666 12.0384 5.90607 12.838 5.90607C13.6377 5.90607 14.2883 6.55662 14.2883 7.3563C14.2883 7.82899 14.6715 8.21217 15.1442 8.21217C15.6169 8.21217 16 7.82899 16 7.3563C16 5.61281 14.5815 4.19434 12.838 4.19434ZM8.89625 12.3351V13.4663C8.89625 13.8365 8.5961 14.1367 8.22585 14.1367C7.8556 14.1367 7.55545 13.8365 7.55545 13.4663V12.3351C7.30361 12.1366 7.14172 11.8291 7.14172 11.4835C7.14172 10.8847 7.62708 10.3994 8.22585 10.3994C8.82461 10.3994 9.30998 10.8847 9.30998 11.4835C9.30998 11.8291 9.14809 12.1366 8.89625 12.3351Z",
    fill: "#A6F9FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10755_8718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLocked);
export default __webpack_public_path__ + "static/media/unLocked.9875eb61793bc8df1dffe19cdfe5da7a.svg";
export { ForwardRef as ReactComponent };